import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
/* box sizing fix - https://css-tricks.com/box-sizing */
html {
  box-sizing: border-box;
  overscroll-behavior: none;
  scroll-behavior: smooth;
}

*,
*:before,
*:after {
  overscroll-behavior: none;
  box-sizing: inherit;
}

/* Responsive images */
img {
  max-width: 100%;
}

/* Reset ul styles */
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

body {
  height: 100%;
  overflow: scroll;
}
`;

export default GlobalStyles;
